import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import SupportRequestModal from './SupportRequestModal'

const SupportCard: React.FC = () => {
  const [supportModalOpen, setSupportModalOpen] = useState(false)

  return (
    <section className="flex min-h-[152px] flex-col items-end gap-4 rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-lg shadow-gray-900/10">
      <h2 className="self-stretch text-base font-semibold text-[#002C22]">
        <FormattedMessage id="home.support.heading" defaultMessage="We are here to help" />
      </h2>
      <p className="text-text-body self-stretch text-sm leading-6">
        <FormattedMessage
          id="home.support.body"
          defaultMessage="Reach out with any question about your results, consents, scheduling, or your account. A member of our care team will follow up with you."
        />
      </p>
      <button
        type="button"
        onClick={() => setSupportModalOpen(true)}
        className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#E5E7EB] bg-[#F3F4F6] px-3 py-2 text-sm font-semibold text-gray-700 shadow-[0_1px_0.5px_0.05px_rgba(29,41,61,0.02)] transition hover:bg-gray-200 focus:ring-2 focus:ring-[#006045]/20 focus:outline-none"
      >
        <FormattedMessage id="home.support.contactButton" defaultMessage="Contact support" />
      </button>
      <SupportRequestModal isOpen={supportModalOpen} onClose={() => setSupportModalOpen(false)} />
    </section>
  )
}

export default SupportCard
